import React, { Component } from 'react';
import './App.css';
import logotipo from './images/Logotipo.png'
import Navigation from './components/Navigation/Navigation'
import Cover from './components/Cover/Cover'
import Footer from './components/Footer/Footer'
import Vision from './components/Vision/Vision'
import Team from './components/Team/Team'
import Announcements from './components/Announcements/Announcements'
import Events from './components/Events/Events'
import Media from './components/Media/Media'
import Enrollment from './components/Enrollment/Enrollment'
import PageLoading from './components/PageLoading/PageLoading'
import About from './components/About/About'
import * as contentful from 'contentful'
import { TwitterTimelineEmbed } from 'react-twitter-embed'

//Images
import space from './images/gallery/Espacio-eidefut.JPG'
import sub10 from './images/gallery/sub-10.jpg'
import sub12 from './images/gallery/sub-12.jpg'
import sub14 from './images/gallery/sub-14.jpg'
import sub16 from './images/gallery/sub-16.jpg'

const initialState = {
  loading: true,
  route: 'home'
}

const sortArray = (target) => {
  target.sort((a, b) => {
    return new Date(b.sys.createdAt) - new Date(a.sys.createdAt)
  })
}
class App extends Component {
  constructor() {
    super();
    this.state = initialState;
  }

  componentDidMount() {
    var client = contentful.createClient({
      space: 'yt3hdxr60xdx',
      accessToken: 'JnfyCjf6LGVn4axNWFcub7_I8I5njFA53b8fPfW4JBw'
    })

    client.getEntries().then(entries => {
      this.setState({
        loading: false,
        items: entries.items
      })
    })

  }

  changeRoute = (route) => {
    this.setState({ route: route });
  }

  render() {

    let body;

    const { route, loading, items } = this.state;

    if (loading) {
      return <PageLoading />
    }

    const announcements = items.filter(item => {
      return item.sys.contentType.sys.id === 'anuncios';
    })

    sortArray(announcements)

    const events = items.filter(item => {
      return item.sys.contentType.sys.id === 'eventos';
    })
    sortArray(events)

    const media = items.filter(item => {
      return item.sys.contentType.sys.id === 'media';
    })
    sortArray(media)

    switch (route) {
      case 'home':
        body = <div>
          <h1>BIENVENIDOS A</h1>
          <img className="home-logotype" alt="Eidefut" src={logotipo} />
          <h2>Escuela de Iniciación Deportiva de Fútbol Sala</h2>
          <Cover />
          <h1>Conócenos</h1>
          <div className="row mx-4">
            <div className="col-12 col-lg-6 px-4 my-2">
              <img src={space} className="gallery-img" alt="Espacio Eidefut" />
              <h5 className="text-center">Nuestros espacios</h5>
            </div>
            <div className="col-12 col-lg-6 px-4 my-2">
              <img src={sub10} className="gallery-img" alt="Equipo Sub 10" />
              <h5 className="text-center">Equipo Sub 10</h5>
            </div>
            <div className="col-12 col-lg-6 px-4 my-2">
              <img src={sub12} className="gallery-img" alt="Equipo Sub 12" />
              <h5 className="text-center">Equipo Sub 12</h5>
            </div>
            <div className="col-12 col-lg-6 px-4 my-2">
              <img src={sub14} className="gallery-img" alt="Equipo Sub 14" />
              <h5 className="text-center">Equipo Sub 14</h5>
            </div>
            <div className="col-12 col-lg-6 px-4 my-2">
              <img src={sub16} className="gallery-img" alt="Equipo Sub 16" />
              <h5 className="text-center">Equipo Sub 16</h5>
            </div>
          </div>
          <TwitterTimelineEmbed
            sourceType="profile"
            screenName="clubeidefut"
            options={{ height: 401, width: 1000 }} />
        </div>;
        break;
      case 'vision':
        body = <Vision />;
        break;
      case 'equipo':
        body = <Team data={items} />;
        break;
      case 'anuncios':
        body = <Announcements announcements={announcements} />;
        break;
      case 'eventos':
        body = <Events events={events} />;
        break;
      case 'media':
        body = <Media media={media} />;
        break;
      case 'inscripcion':
        body = <Enrollment />;
        break;
      case 'acerca':
        body = <About />;
        break;
      default:
        body = <div>
          <Cover />
          <TwitterTimelineEmbed
            sourceType="profile"
            screenName="clubeidefut"
            options={{ height: 401, width: 1000 }} />
        </div>;
        break;
    }
    return (
      <div className="App">
        <Navigation changeRoute={this.changeRoute} />
        { body}
        <Footer />
      </div>
    );
  }
}

export default App;
